export default "__VITE_PUBLIC_ASSET__d6c226c7__"